<div class="back-container">
  <span class="button-group">

    <button
      pButton
      pRipple
      type="button"
      class="scroll-button"
      [ngClass]="{ 'hidden': !showTopButton }"
      title="Subir"
      pTooltip="Subir"
      tooltipPosition="left"
      (click)="toTop()"
    >
      <fa-icon [icon]="['fas', 'angle-up']"></fa-icon>
    </button>

    <button
      pButton
      pRipple
      type="button"
      class="scroll-button"
      [ngClass]="{ 'hidden': !showBottomButton }"
      title="Bajar"
      pTooltip="Bajar"
      tooltipPosition="left"
      (click)="toBottom()"
    >
      <fa-icon [icon]="['fas', 'angle-down']"></fa-icon>
    </button>

  </span>
</div>